import React, { useEffect, useState, useContext } from "react";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import styled from 'styled-components';
import { StyledForm } from "../../styled-components/StyledForm.style";
import api from '../../services/api';
import Swal from "sweetalert2";

const GridRow = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 1rem;
  padding: 0.5rem 0;
  align-items: center;
  border-bottom: 1px solid #eee;
  background: ${props => props.probono ? '#cdeeff' : 'transparent'};
`;

const HeaderRow = styled(GridRow)`
  font-weight: bold;
  background-color: #f5f5f5;
  margin-right: ${(props) => (props.scrollActive ? '1.5rem' : '0.5rem')};
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
`;

const BtnLink = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  font-size: 1rem;

  &:hover {
    color: #0056b3;
  }
`;

const ScrollContainer = styled.div`
  max-height: 300px;
  overflow-y: auto;
  margin-top: 1rem;
  padding-right: 0.5rem;
`;

export const ModalAprovacaoEmMassa = ({
    loadTable,
    isOpen,
    setIsOpen,
    aprovacaoEmMassaList
}) => {
    const style = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '60%',
            overflowY: 'auto',
            minHeight: '50%',
            maxHeight: '90%'
        },
        overlay: {
            zIndex: 9999
        }
    };

    const closeModal = () => {
        setIsOpen(false);
    }

    const formAprovacao = async () => {
        var idsPendenciaAprovacao = aprovacaoEmMassaList.map(item => item.idPendenciaAprovacao);

        let payload = {
            idsPendenciaAprovacao,
            descricao: "descricao",
            // Aprovado
            Status: 2,
            // Aprovar
            IdTipoAcao: 2
        }

        let existeProbono = aprovacaoEmMassaList.some(item => item.atividadesProbono > 0);
        if(existeProbono) {
            proBonoValidation(payload)
        }
        else {
            await handleAprovacaoEmMassa(payload)
        }
    }

    const proBonoValidation = (payload) => {
        Swal.fire({
            text: `Existe ao menos um TS com horas Pro bono. Deseja seguir com a aprovação?`,
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
        }).then(async (result) => {
            if (result.isConfirmed) {
                await handleAprovacaoEmMassa(payload)
            }
        });
    }

    const handleAprovacaoEmMassa = async (payload) => {
        Swal.fire({
            title: 'Aguarde...',
            html: 'Aprovando...',
            allowEscapeKey: false,
            allowOutsideClick: false,
            showConfirmButton: false,
            willOpen: () => {
                Swal.showLoading()
            },
        });

        await api.put(`Aprovacoes/status:em-massa`, payload)
            .then(async (response) => {
                await loadTable()
                setIsOpen(false);
                registrationSuccess();
            })
            .catch((error) => {
                registrationFailure(error?.response?.data?.notification?.messageReturn)
            });
    }

    const registrationSuccess = () => {
        Swal.fire({
            title: "Sucesso",
            text: "Aprovados com sucesso",
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
            didClose: () => {
                window.location.reload();
            }
        });
    }

    const registrationFailure = (text = "Ops, ocorreu um erro!. Tente novamente em instantes.") => {
        Swal.fire({
            title: "Atenção",
            text: text,
            icon: "error",
            confirmButtonText: "OK",
        });
    }

    const isProBonoMaiorQueZero = (valor) => {
        if (typeof valor === 'string') {
            valor = valor.replace(',', '.');
        }

        const numero = Number(valor);

        return !isNaN(numero) && numero > 0;
    };

    const somarHoras = () => {
        const totalHoras = aprovacaoEmMassaList.reduce((total, item) => {
            const horas = parseFloat(item.horasTimeSheet.replace(',', '.') || 0);
            return total + horas;
        }, 0);

        return totalHoras.toFixed(2).replace('.', ',');
    };

    const somarProBono = () => {
        const totalProBono = aprovacaoEmMassaList.reduce((total, item) => {
            const proBono = parseFloat(item.totalHorasProBono.replace(',', '.') || 0);
            return total + proBono;
        }, 0);

        return totalProBono.toFixed(2).replace('.', ',');
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            contentLabel="Timesheet Atividades"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledForm>
                <p className="modal-close" onClick={closeModal}>X</p>
            </StyledForm>

            <StyledForm>
                <Flex>
                    <Flex.Item className="modal-width">
                        <p className="modal-title">Aprovação em Massa</p>
                    </Flex.Item>
                </Flex>

                <Flex>
                    <Flex.Item className="modal-width">
                        <div className="position-relative form-group">
                            <div>
                                <p className="modal-info">{
                                    aprovacaoEmMassaList.length > 1
                                        ? `Deseja aprovar as ${aprovacaoEmMassaList.length} atividades selecionadas?`
                                        : `Deseja aprovar a atividade selecionada?`
                                }</p>
                            </div>
                        </div>
                    </Flex.Item>
                </Flex>

                <Flex style={{ flexDirection: 'column' }}>
                    {aprovacaoEmMassaList && aprovacaoEmMassaList.length > 0 && (
                        <>
                            <div className="grid grid-cols-3 gap-2 fw-bold">
                                <HeaderRow scrollActive={aprovacaoEmMassaList.length >= 8}>
                                    <span>Laudo</span>
                                    <span>TS</span>
                                    <span>Data</span>
                                    <span>Líder</span>
                                    <span>Horas</span>
                                    <span>Probono</span>
                                </HeaderRow>
                            </div>

                            <ScrollContainer>
                                {aprovacaoEmMassaList.map((item, index) => (
                                    <div key={index} className="modal-width">
                                        <GridRow probono={isProBonoMaiorQueZero(item.totalHorasProBono)}>
                                            <span>{item.sigla}</span>
                                            <span>{item.timeSheetSigla}</span>
                                            <span>{item.dataPrazo}</span>
                                            <span>{item.lider}</span>
                                            <span>{item.horasTimeSheet}</span>
                                            <span>{item.totalHorasProBono}</span>
                                        </GridRow>
                                    </div>
                                ))}
                            </ScrollContainer>

                            <div className="grid grid-cols-3 gap-2 fw-bold">
                                <HeaderRow scrollActive={aprovacaoEmMassaList.length >= 8}>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                    <span style={{ color: "red" }}>{somarHoras()}</span>
                                    <span style={{ color: "red" }}>{somarProBono()}</span>
                                </HeaderRow>
                            </div>
                        </>
                    )}
                </Flex>

                <ButtonRow>
                    <BtnLink onClick={closeModal}>Fechar</BtnLink>
                    <input className="default-button-red" value="Aprovar" type="button" onClick={formAprovacao} />
                </ButtonRow>

            </StyledForm>
        </Modal>);
};
